export type OSName =
  | 'Windows'
  | 'Windows Phone'
  | 'macOS'
  | 'Linux'
  | 'Android'
  | 'iOS'
  | 'Unknown OS'

export async function detectOS(): Promise<OSName> {
  if (navigator.userAgentData) {
    // Если ошибка, нужно добавить "./src/common/types/global.ts" в tsconfig.json в include секцию
    const uaData = await navigator.userAgentData.getHighEntropyValues(['platform'])
    const platform = uaData.platform

    // Можно сразу отдать platform, но лучше нормализовать
    switch (platform) {
      case 'Windows':
        return 'Windows'
      case 'macOS':
        return 'macOS'
      case 'Linux':
        return 'Linux'
      case 'Android':
        return 'Android'
      case 'iOS':
        return 'iOS'
      default:
        return 'Unknown OS'
    }
  }

  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera

  if (/windows phone/i.test(userAgent)) return 'Windows Phone'
  if (/windows/i.test(userAgent)) return 'Windows'
  if (/macintosh|mac os x/i.test(userAgent)) return 'macOS'
  if (/linux/i.test(userAgent)) return 'Linux'
  if (/android/i.test(userAgent)) return 'Android'
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'iOS'

  return 'Unknown OS'
}
